var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autoLogin"},[_c('img',{attrs:{"src":require("./loading.gif"),"alt":""}}),_c('p',[_vm._v("自动登录中，请稍后 ... ")])])}]

export { render, staticRenderFns }